import type { SVGProps } from 'react';

export const ArrowDownSFSymbolRegular = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 15.166 18.4473"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="18.4473" opacity="0" width="15.166" x="0" y="0" />{' '}
        <path
          d="M7.40234 18.4473C7.64648 18.4473 7.87109 18.3496 8.05664 18.1543L14.541 11.6602C14.7266 11.4648 14.8047 11.2598 14.8047 11.0254C14.8047 10.5469 14.4531 10.1758 13.9648 10.1758C13.7305 10.1758 13.5059 10.2539 13.3496 10.4102L11.123 12.5977L7.39258 16.6797L3.68164 12.5977L1.45508 10.4102C1.30859 10.2539 1.07422 10.1758 0.839844 10.1758C0.351562 10.1758 0 10.5469 0 11.0254C0 11.2598 0.0878906 11.4648 0.273438 11.6602L6.74805 18.1543C6.93359 18.3496 7.1582 18.4473 7.40234 18.4473ZM7.40234 17.4023C7.86133 17.4023 8.17383 17.0898 8.17383 16.6309L8.27148 13.7207L8.27148 0.859375C8.27148 0.351562 7.91016 0 7.40234 0C6.89453 0 6.5332 0.351562 6.5332 0.859375L6.5332 13.7207L6.63086 16.6309C6.63086 17.0898 6.94336 17.4023 7.40234 17.4023Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
